<template>
  <!-- 导出国家级报告 -->
  <div class="analysisReport">
    <el-button type="primary" class="export" @click="exportPdf">导出pdf</el-button>
    <div class="analysisReport_box" ref="pdfContent">
        <span v-show="false">这是completeNum的值：{{completeNum  }}</span>
      <input id="completeNum" v-model="completeNum" v-show="false" />
      <div class="chart_box page-box">
        <h6 style="margin-top: 0">2.1.4.5.2 按照用户活跃情况分析</h6>
        <p>
          国家级资源库项目中，“{{ countryUserRank[0].name }}资源库”的活跃用户数最多，紧随其后的是“{{
            countryUserRank[1].name
          }}资源库”和“{{ countryUserRank[2].name }}资源库”。
        </p>
        <div class="chart_name">表4 国家级资源库活跃用户排名情况（前十五名）</div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>资源库名称</th>
              <th>用户总数</th>
              <th>活跃用户数</th>
            </tr>
            <tr v-if="countryUserRank.length == 0" class="nothing">
              <td colspan="4">无</td>
            </tr>
            <tr v-else v-for="(item, index) in countryUserRank" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.totalValue }}</td>
              <td>{{ item.value }}</td>
            </tr>
          </table>
        </div>
        <h4>2.2 各省建设及应用情况</h4>
        <h5 style="margin-top: 0">2.2.1 各省用户建设及应用情况</h5>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，注册用户总计{{
            getUtils_Fun(provinceUser.zykUserNum)
          }}人，其中注册用户最多的是{{
            changeCity(provinceUser.maxRegisteredUsersProvince.province)
          }}资源库，达{{
            getUtils_Fun(provinceUser.maxRegisteredUsersProvince.num)
          }}人；交流互动量次数累计{{
            getUtils_Fun(provinceUser.forumLogProvinceNumTotal)
          }}次，互动交流频次最多的是{{
            changeCity(provinceUser.maxInteractiveUsersProvince.province)
          }}资源库，共{{
            getUtils_Fun(provinceUser.maxInteractiveUsersProvince.num)
          }}次；活跃用户总数{{
            getUtils_Fun(provinceUser.provinceStatusActiveUserTotal)
          }}人，活跃用户数最多的是{{
            changeCity(provinceUser.provinceStatusActiveUser.province)
          }}资源库，共{{ getUtils_Fun(provinceUser.provinceStatusActiveUser.activeNum) }}人。
          具体各省资源库用户按照活跃用户数排名 (前十五名)如下表所示：
        </p>
        <div class="chart_name">表5 各省资源库活跃用户数排名（前十五名）</div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>省份</th>
              <th>资源库数（个）</th>
              <th>注册用户数（人）</th>
              <th>活跃用户数（人）</th>
              <th>交流互动量（次）</th>
            </tr>
            <tr v-if="provinceUser.provinceStatusActiveUserRank.length == 0" class="nothing">
              <td colspan="6">无</td>
            </tr>
            <tr
              v-else
              v-for="(item, index) in provinceUser.provinceStatusActiveUserRank.slice(0, 15)"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.province }}</td>
              <td>{{ item.zykCount }}</td>
              <td>{{ item.num }}</td>
              <td>{{ item.activeNum }}</td>
              <td>{{ item.formun }}</td>
            </tr>
          </table>
        </div>
        <p class="notes">
          注：“各省资源库” 均以该资源库的第一主持院校所在地来确定该资源库所归属的省份。
        </p>
      </div>

      <div class="chart_box page-box">
        <div class="standards_content echartsHeight" style="height: 1000px">
          <distributionChart
            :refId="'userTalk'"
            :datas="provinceUser.provinceLogTotal"
            :color="mapcolorList"
            :isExportFont="18"
            :zoom="true"
          ></distributionChart>
        </div>
        <div class="chart_name">图36 各省资源库访问热力图</div>
        <h5 class="m-top100">2.2.2 各省课程建设及应用情况</h5>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，资源库建设课程总计{{
            getUtils_Fun(provinceCourse.zykBuildCourseCount)
          }}门，其中建设课程数量最多的是{{
            changeCity(provinceCourse.courseRank[0].name)
          }}资源库，有{{ getUtils_Fun(provinceCourse.courseRank[0].num) }}门；标准化课程数累计有{{
            getUtils_Fun(provinceCourse.standardIntValue)
          }}门， 标准化课程数最多的是{{ provinceCourse.standard.name }}资源库，共{{
            getUtils_Fun(provinceCourse.standard.value)
          }}门，个性化课程数累计有{{
            getUtils_Fun(provinceCourse.personalizationIntlValue)
          }}门，个性化课程数最多的是{{ provinceCourse.personality.name }}资源库，共{{
            getUtils_Fun(provinceCourse.personality.value)
          }}门。 具体各省资源库课程建设按照总课程数排名（前十五名）如下表所示：
        </p>
        <div class="chart_name">表6 各省资源库课程按照课程总量排名（前十五名）</div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>省份</th>
              <th>标准化课程数</th>
              <th>个性化课程数</th>
              <th>总课程数（门）</th>
            </tr>
            <tr v-if="provinceCourse.courseRank.length == 0" class="nothing">
              <td colspan="5">无</td>
            </tr>
            <tr v-else v-for="(item, index) in provinceCourse.courseRank.slice(0, 15)" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.snum }}</td>
              <td>{{ item.pnum }}</td>
              <td>{{ item.num }}</td>
            </tr>
          </table>
        </div>
      </div>

      <div class="chart_box page-box">
        <h5>2.2.3 各省资源建设及应用情况</h5>
        <p v-if="provinceResource.resourceBuildProvinceMax">
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，资源库建设资源累计达{{
            getUtils_Fun(provinceResource.resourceBuildCount)
          }}条，其中建设资源数量最多的是{{
            changeCity(provinceResource.resourceBuildProvinceMax.province)
          }}资源库，有{{
            getUtils_Fun(provinceResource.resourceBuildProvinceMax.num)
          }}条。各省访问资源的总量达{{ getUtils_Fun(provinceResource.resourceTotal) }}次，
          访问资源总量最多的是{{
            changeCity(provinceResource.resourceProvinceVisitMax.province)
          }}资源库。具体各省资源库资源建设按照访问量情况排名（前十五名）如下表所示：
        </p>
        <div class="chart_name">表7 各省资源库资源访问量情况排名（前十五名）</div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>省份</th>
              <th>资源数（条）</th>
              <th>资源量（TB）</th>
              <th>访问量（次）</th>
            </tr>
            <tr v-if="provinceResource.resourceProvinceStateRank.length == 0" class="nothing">
              <td colspan="5">无</td>
            </tr>
            <tr
              v-else
              v-for="(item, index) in provinceResource.resourceProvinceStateRank.slice(0, 15)"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.province1 }}</td>
              <td>{{ item.count }}</td>
              <td>{{ item.disksNum.toFixed(2) }}</td>
              <td>{{ item.log }}</td>
            </tr>
          </table>
        </div>
        <h4 class="m-top100">2.3 {{ startDay }}至{{ endDay }}资源库运行监测分析</h4>
        <h5 style="margin-top: 0">2.3.1 {{ startDay }}至{{ endDay }}资源库用户建设及应用情况</h5>
        <p>1. 用户新增情况</p>
        <p>
          在该时间段内，用户新增总数为{{ getUtils_Fun(userAddCase.total) }}人，其中学生用户新增共{{
            getUtils_Fun(userAddCase.sTotal)
          }}人，教师用户新增共{{ getUtils_Fun(userAddCase.tTotal) }}人。师生用户新增趋势如下图所示：
        </p>
        <div class="standards_content echartsHeight">
          <discountChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'userTalk'"
            :datas="userAddCase.dataList"
            :transverseData="userAddCase.transverse"
            :colorList="colorList"
            :innerText="'单位：人'"
            :legendList="['学生', '教师']"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :circleSize="80"
          ></discountChart>
        </div>
        <div class="chart_name">图37 {{ startDay }}至{{ endDay }}资源库师生用户新增趋势</div>
      </div>

      <div class="chart_box page-box">
        <p>2. 用户活跃情况</p>
        <p v-if="userActiveCase.student && userActiveCase.student.num">
          在该时间段内，资源库项目中累计活跃用户{{
            getUtils_Fun(userActiveCase.userActiveTotal)
          }}人，累计访问{{ getUtils_Fun(userActiveCase.userVisitTotal) }}次。其中，学生活跃用户{{
            getUtils_Fun(userActiveCase.student.num)
          }}人，累计访问共{{ getUtils_Fun(userActiveCase.student.logNum) }}次；教师活跃用户{{
            getUtils_Fun(userActiveCase.teacher.num)
          }}人 ，累计访问共{{ getUtils_Fun(userActiveCase.teacher.logNum) }}次；企业用户{{
            getUtils_Fun(userActiveCase.enterprise.num)
          }}人，累计访问共{{ getUtils_Fun(userActiveCase.enterprise.logNum) }}次； 社会学习者{{
            getUtils_Fun(userActiveCase.social.num)
          }}人， 累计访问共{{
            getUtils_Fun(userActiveCase.social.logNum)
          }}次。各类型用户访问趋势如下图所示：
        </p>
        <div class="standards_content echartsHeight" v-if="userActiveCase.userActiveMonthRole">
          <discountChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'userTalk'"
            :datas="userActiveCase.userActiveMonthRole.dataList"
            :transverseData="userActiveCase.userActiveMonthRole.transverseData"
            :colorList="colorList"
            :innerText="'单位：次'"
            :legendList="userActiveCase.userActiveMonthRole.legendList"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :circleSize="80"
          ></discountChart>
        </div>
        <div class="chart_name">图38 {{ startDay }}至{{ endDay }}资源库各类型用户访问趋势</div>
        <p class="m-top150">3. 用户访问情况排名</p>
        <p>
          在该时间段内，被用户访问最多的资源库是{{ userVisitRank[0].projectTypeCn }}的“{{
            userVisitRank[0].zykName
          }}资源库”。具体被访问资源库排名（前十五名）如下表所示：
        </p>
        <div class="chart_name">
          表8 {{ startDay }}至{{ endDay }}资源库用户访问情况排行榜（前十五名）
        </div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>资源库名称</th>
              <th>第一主持院校</th>
              <th>级别</th>
              <th>访问量（次）</th>
            </tr>
            <tr v-if="userVisitRank.length == 0" class="nothing">
              <td colspan="5">无</td>
            </tr>
            <tr v-else v-for="(item, index) in userVisitRank" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ item.zykName }}</td>
              <td>{{ item.firstChargeUnit }}</td>
              <td>{{ item.projectTypeCn }}</td>
              <td>{{ item.num }}</td>
            </tr>
          </table>
        </div>
      </div>

      <div class="chart_box page-box">
        <h5>2.3.2 {{ startDay }}至{{ endDay }}资源库课程建设及应用情况</h5>
        <p>
          在该时间段内，资源库新增课程总数共{{
            getUtils_Fun(courseBuildAnalysis.totalCourseNum)
          }}门，其中标准化课程{{ courseBuildAnalysis.sNum }}门，个性化课程{{
            courseBuildAnalysis.pNum
          }}门。具体课程新增趋势如下图所示：
        </p>
        <div class="standards_content echartsHeight">
          <discountChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'resourcesMonthChart'"
            :datas="courseBuildAnalysis.courseNew.value"
            :transverseData="courseBuildAnalysis.courseNew.name"
            :colorList="colorList"
            :colorName="1"
            :innerText="'单位：门'"
            :isaverage="true"
          ></discountChart>
        </div>
        <div class="chart_name">图39 {{ startDay }}至{{ endDay }}资源库课程新增趋势</div>
        <p class="m-top150">
          在该时间段内，被访问量居首的课程是《{{
            courseBuildAnalysis.zykCourseRank[0].name
          }}》，有{{
            getUtils_Fun(courseBuildAnalysis.zykCourseRank[0].num)
          }}次，具体课程按照访问量排名（前十五名）如下表所示：
        </p>
        <div class="chart_name">
          表9 {{ startDay }}至{{ endDay }}资源库课程被访问量排名（前十五名）
        </div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>课程名称</th>
              <th>所属资源库</th>
              <th>第一主持单位</th>
              <th>级别</th>
              <th>访问量</th>
            </tr>
            <tr v-if="courseBuildAnalysis.zykCourseRank.length == 0" class="nothing">
              <td colspan="6">无</td>
            </tr>
            <tr v-else v-for="(item, index) in courseBuildAnalysis.zykCourseRank" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.zyk_name }}</td>
              <td>{{ item.first_charge_unit }}</td>
              <td>{{ item.project_type_cn }}</td>
              <td>{{ item.num }}</td>
            </tr>
          </table>
        </div>
      </div>

      <div class="chart_box page-box">
        <h5>2.3.3 {{ startDay }}至{{ endDay }}资源库资源建设及应用情况</h5>
        <p>
          在该时间段内，资源库新增资源数为{{
            getUtils_Fun(resourceBuildAnalysis.total)
          }}条，具体资源库新增资源数排名（前十五名）情况如下：
        </p>
        <div class="standards_content echartsHeight m-top100">
          <circularChart
            :isShowTextColor="true"
            :refId="'typeDistributionChart'"
            :datas="resourceBuildAnalysis.pieDataList"
            :colorName="1"
            :innerText="'数量'"
            :titleLeft="'32%'"
            :showValue="true"
            :unit="'条'"
            :legendBackgroundColor="true"
            :legendLeft="'50%'"
            :circleSize="80"
          >
          </circularChart>
        </div>
        <div class="chart_name">图40 {{ startDay }}至{{ endDay }}资源库新增资源类型分布情况</div>
        <div class="chart_name">
          表10 {{ startDay }}至{{ endDay }}资源库按照新增的资源数排名（前十五名）
        </div>
        <div class="biaoge" style="height: auto">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>资源库</th>
              <th>第一主持院校</th>
              <th>级别</th>
              <th>新增资源数</th>
            </tr>
            <tr v-if="resourceBuildAnalysis.newRank.length == 0" class="nothing">
              <td colspan="5">无</td>
            </tr>
            <tr v-else v-for="(item, index) in resourceBuildAnalysis.newRank" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ item.zyk_name }}</td>
              <td>{{ item.first_charge_unit }}</td>
              <td>{{ item.project_type_cn }}</td>
              <td>{{ item.num }}</td>
            </tr>
          </table>
        </div>
      </div>

      <div class="chart_box page-box">
        <p>
          在该时间段内，资源库资源被访问总量达{{
            getUtils_Fun(resourceBuildAnalysis.totalLog)
          }}次，其中，“{{
            resourceBuildAnalysis.logRank[0].zyk_name
          }}资源库”的资源被访问的次数最多。资源库按照资源被访问量排名（前十五名）如下表所示：
        </p>
        <div class="chart_name">
          表11 {{ startDay }}至{{ endDay }}资源库按照资源被访问量排名（前十五名）
        </div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>资源库</th>
              <th>第一主持院校</th>
              <th>级别</th>
              <th>资源访问量</th>
            </tr>
            <tr v-if="resourceBuildAnalysis.logRank.length == 0" class="nothing">
              <td colspan="5">无</td>
            </tr>
            <tr v-else v-for="(item, index) in resourceBuildAnalysis.logRank" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ item.zyk_name }}</td>
              <td>{{ item.first_charge_unit }}</td>
              <td>{{ item.project_type_cn }}</td>
              <td>{{ item.num }}</td>
            </tr>
          </table>
        </div>
        <h5 class="m-top150">2.3.4 {{ startDay }}至{{ endDay }}国家级资源库建设及应用情况</h5>
        <h6 style="margin-top: 0">2.3.4.1 用户运行情况</h6>
        <p>1. 用户新增情况</p>
        <p>
          在该时间段内，国家级资源库中新增用户总数为{{
            getUtils_Fun(userRunCase.userTotal)
          }}人，其中学生用户新增共{{ getUtils_Fun(userRunCase.sTotal) }}人，教师用户新增共{{
            getUtils_Fun(userRunCase.tTotal)
          }}人。师生用户新增趋势如下图所示：
        </p>
        <div class="standards_content echartsHeight">
          <discountChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'userTalk'"
            :datas="userRunCase.userAddDataList"
            :transverseData="userRunCase.userAddTransverse"
            :colorList="colorList"
            :innerText="'单位：人'"
            :legendList="['教师', '学生']"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :circleSize="80"
          ></discountChart>
        </div>
        <div class="chart_name">图41 {{ startDay }}至{{ endDay }}国家级资源库师生用户新增趋势</div>
      </div>

      <div class="chart_box page-box">
        <p>2. 用户活跃情况</p>
        <p v-if="userRunCase.activeStudent && userRunCase.activeStudent.num">
          在该时间段内，国家级资源库项目中累计活跃用户{{
            getUtils_Fun(userRunCase.activeUserTotal)
          }}人，累计访问{{ getUtils_Fun(userRunCase.logTotal) }}次。其中，学生活跃用户{{
            getUtils_Fun(userRunCase.activeStudent.num)
          }}人，累计访问共{{ getUtils_Fun(userRunCase.activeStudent.logNum) }}次；教师活跃用户{{
            getUtils_Fun(userRunCase.activeTeacher.num)
          }}人，累计访问共{{ getUtils_Fun(userRunCase.activeTeacher.logNum) }}次；企业用户{{
            getUtils_Fun(userRunCase.activeEnterprise.num)
          }}人，累计访问共{{ getUtils_Fun(userRunCase.activeEnterprise.logNum) }}次； 社会学习者{{
            getUtils_Fun(userRunCase.activeSocial.num)
          }}人，累计访问共{{
            getUtils_Fun(userRunCase.activeSocial.logNum)
          }}次。各类型用户访问趋势如下图所示：
        </p>
        <div class="standards_content echartsHeight">
          <discountChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'userTalk'"
            :datas="userRunCase.userActiveLine.dataList"
            :transverseData="userRunCase.userActiveLine.transverseData"
            :colorList="colorList"
            :innerText="'单位：次'"
            :legendList="userRunCase.userActiveLine.legendList"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :circleSize="80"
          ></discountChart>
        </div>
        <div class="chart_name">
          图42 {{ startDay }}至{{ endDay }}国家级资源库各类型用户访问趋势
        </div>
        <p class="m-top150">3. 用户访问情况排名</p>
        <p v-if="userRunCase.top15UserVisitRank">
          在该时间段内，被用户访问最多的国家级资源库是“{{
            userRunCase.top15UserVisitRank[0].zykName
          }}资源库”。具体被访问资源库排名（前十五名）和（后十五名）如下表所示：
        </p>
        <div class="chart_name">
          表12 {{ startDay }}至{{ endDay }}国家级资源库访问量排行榜（前十五名）
        </div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>序号</th>
              <th>资源库名称</th>
              <th>第一主持院校</th>
              <th>访问量（次）</th>
            </tr>
            <tr v-if="userRunCase.top15UserVisitRank.length == 0" class="nothing">
              <td colspan="4">无</td>
            </tr>
            <tr v-else v-for="(item, index) in userRunCase.top15UserVisitRank" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ item.zykName }}</td>
              <td>{{ item.firstChargeUnit }}</td>
              <td>{{ item.num }}</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="chart_box page-box">
        <div class="chart_name">
          表13 {{ startDay }}至{{ endDay }}国家级资源库访问量排行榜（后十五名）
        </div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>序号</th>
              <th>资源库名称</th>
              <th>第一主持院校</th>
              <th>访问量（次）</th>
            </tr>
            <tr v-if="userRunCase.last15UserVisitRank.length == 0" class="nothing">
              <td colspan="4">无</td>
            </tr>
            <tr v-else v-for="(item, index) in userRunCase.last15UserVisitRank" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ item.zykName }}</td>
              <td>{{ item.firstChargeUnit }}</td>
              <td>{{ item.num }}</td>
            </tr>
          </table>
        </div>
        <h6>2.3.4.2 课程运行情况</h6>
        <p>
          在该时间段内，国家级资源库新增课程总数共{{
            getUtils_Fun(courseRunCase.total)
          }}门，其中标准化课程新增{{ getUtils_Fun(courseRunCase.sNum) }}门，个性化课程新增{{
            getUtils_Fun(courseRunCase.pMum)
          }}门。具体课程新增趋势如下图所示：
        </p>
        <div class="standards_content echartsHeight">
          <discountChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'resourcesMonthChart'"
            :datas="courseRunCase.courseNew.value"
            :transverseData="courseRunCase.courseNew.name"
            :colorList="colorList"
            :colorName="1"
            :innerText="'单位：门'"
            :isaverage="true"
          ></discountChart>
        </div>
        <div class="chart_name">图43 {{ startDay }}至{{ endDay }}国家级资源库课程新增趋势</div>
        <p>
          在该时间段内，被访问量居首的课程是《{{
            courseRunCase.top15CourseVisitRank[0].name
          }}》，有{{
            getUtils_Fun(courseRunCase.top15CourseVisitRank[0].num)
          }}次，具体课程按照访问量排名（前十五名）如下表所示：
        </p>
        <div class="chart_name">表14 国家级资源库课程被访问量排名（前十五名）</div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>课程名称</th>
              <th>所属资源库</th>
              <th>第一主持单位</th>
              <th>访问量</th>
            </tr>
            <tr v-if="courseRunCase.top15CourseVisitRank.length == 0" class="nothing">
              <td colspan="5">无</td>
            </tr>
            <tr v-else v-for="(item, index) in courseRunCase.top15CourseVisitRank" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.zyk_name }}</td>
              <td>{{ item.first_charge_unit }}</td>
              <td>{{ item.num }}</td>
            </tr>
          </table>
        </div>
      </div>

      <div class="chart_box page-box">
        <h6 style="margin: 0">2.3.4.3 资源运行情况</h6>
        <p>
          在该时间段内，国家级资源库新增资源数为{{
            getUtils_Fun(resourceRunCase.total)
          }}条，具体资源库新增资源数排名（前十五名）情况如下表所示：
        </p>
        <div class="standards_content echartsHeight">
          <circularChart
            :isShowTextColor="true"
            :refId="'typeDistributionChart'"
            :datas="resourceRunCase.pieDataList"
            :colorName="1"
            :innerText="'数量'"
            :titleLeft="'32%'"
            :showValue="true"
            :unit="'条'"
            :legendBackgroundColor="true"
            :legendLeft="'50%'"
            :circleSize="80"
          ></circularChart>
        </div>
        <div class="chart_name">图44 国家级资源库新增资源类型分布情况</div>
        <div class="chart_name">
          表15 {{ startDay }}至{{ endDay }}国家级资源库按照新增的资源数排名（前十五名）
        </div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>资源库</th>
              <th>第一主持院校</th>
              <th>新增资源数</th>
            </tr>
            <tr v-if="resourceRunCase.newRank.length == 0" class="nothing">
              <td colspan="4">无</td>
            </tr>
            <tr v-else v-for="(item, index) in resourceRunCase.newRank" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ item.zyk_name }}</td>
              <td>{{ item.first_charge_unit }}</td>
              <td>{{ item.num }}</td>
            </tr>
          </table>
        </div>
        <p>
          在该时间段内，国家级资源库资源被访问总量达{{
            getUtils_Fun(resourceRunCase.totalLog)
          }}次，其中，“{{
            resourceRunCase.logRank[0].zyk_name
          }}资源库”的资源被访问的次数最多。资源库按照资源被访问量排名（前十五名）如下表所示：
        </p>
        <div class="chart_name">
          表16 {{ startDay }}至{{ endDay }}国家级资源库按照资源被访问量排名（前十五名）
        </div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>资源库</th>
              <th>第一主持院校</th>
              <th>资源访问量</th>
            </tr>
            <tr v-if="resourceRunCase.logRank.length == 0" class="nothing">
              <td colspan="4">无</td>
            </tr>
            <tr v-else v-for="(item, index) in resourceRunCase.logRank" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ item.zyk_name }}</td>
              <td>{{ item.first_charge_unit }}</td>
              <td>{{ item.num }}</td>
            </tr>
          </table>
        </div>
      </div>

      <div class="chart_box page-box">
        <div class="division">3. 在线精品课建设及应用情况</div>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{
            nowDay
          }}日，依据专业与课程服务中心监测平台统计，在线精品课共纳入监测{{
            onlineCourseBuild.onlineCourseNum
          }}门，其中，国家级课程有{{ onlineCourseBuild.countryVal }}门，省级课程有{{
            onlineCourseBuild.provinceVal
          }}门，校级课程有{{ onlineCourseBuild.schoolVal }}门。目前，在线精品课程已有{{
            onlineCourseBuild.school
          }}所院校和{{ getUtils_Fun(onlineCourseBuild.teacher) }}名教师参与建设与应用；总访问量达{{
            getUtils_Fun(onlineCourseBuild.totalVisit)
          }}次，总开课期数为{{ getUtils_Fun(onlineCourseBuild.totalCourse) }}期，总课时数为{{
            getUtils_Fun(onlineCourseBuild.totalClass)
          }}课时， 总选课人数{{ getUtils_Fun(onlineCourseBuild.totalStudent) }}人，总互动次数{{
            getUtils_Fun(onlineCourseBuild.totalInteract)
          }}次。具体建设及应用情况如下：
        </p>
        <h5>3.1 各省在线精品课建设情况</h5>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，在线精品课共纳入监测{{
            porvinceOnlineCourse.total
          }}门，其中，{{
            changeCity(porvinceOnlineCourse.dataList[0].province)
          }}建设课程数量最多，共{{
            porvinceOnlineCourse.dataList[0].total
          }}门，具体各省建设课程数量排名（前十五名）如下表所示：
        </p>
        <div class="chart_name">表17 各省建设在线精品课程数量排名（前十五名）</div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>省份</th>
              <th>建设课程数</th>
              <th>选课人数</th>
            </tr>
            <tr v-if="porvinceOnlineCourse.dataList.length == 0" class="nothing">
              <td colspan="4">无</td>
            </tr>
            <tr
              v-else
              v-for="(item, index) in porvinceOnlineCourse.dataList.slice(0, 15)"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.province }}</td>
              <td>{{ item.total }}</td>
              <td>{{ item.studynum }}</td>
            </tr>
          </table>
        </div>
        <h5 style="margin-top: 0">3.2 在线精品课访问情况</h5>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，在线精品课程共计访问量{{
            getUtils_Fun(onlineCourseVisit.onlineCourseTotalVisit)
          }}，访问量最高的课程是{{ onlineCourseVisit.onlineCourseVisitRank[0].schoolname }}的《{{
            onlineCourseVisit.onlineCourseVisitRank[0].name
          }}》，访问量排名（前十五名）的课程信息如下表所示：
        </p>
        <div class="chart_name">表18 在线精品课访问量排名（前十五名）</div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>课程名称</th>
              <th>课程负责人</th>
              <th>所属院校</th>
              <th>级别</th>
              <th>访问量</th>
            </tr>
            <tr v-if="onlineCourseVisit.onlineCourseVisitRank.length == 0" class="nothing">
              <td colspan="6">无</td>
            </tr>
            <tr
              v-else
              v-for="(item, index) in onlineCourseVisit.onlineCourseVisitRank"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.teacher }}</td>
              <td>{{ item.schoolname }}</td>
              <td>{{ item.level }}</td>
              <td>{{ item.num }}</td>
            </tr>
          </table>
        </div>
      </div>

      <div class="chart_box page-box">
        <h5>3.3 在线精品课开课情况</h5>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，在线精品课程共计开课期数{{
            getUtils_Fun(onlineCourseOpen.onlineCourseTotalOpenNum)
          }}期，开课期数最多的课程是{{ onlineCourseOpen.onlineCourseOpenRank[0].schoolname }}的《{{
            onlineCourseOpen.onlineCourseOpenRank[0].name
          }}》，开课期数排名（前十五名）的课程信息如下表所示：
        </p>
        <div class="chart_name">表19 在线精品课开课期数排名（前十五名）</div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>课程名称</th>
              <th>课程负责人</th>
              <th>所属院校</th>
              <th>级别</th>
              <th>开课期数</th>
            </tr>
            <tr v-if="onlineCourseOpen.onlineCourseOpenRank.length == 0" class="nothing">
              <td colspan="6">无</td>
            </tr>
            <tr v-else v-for="(item, index) in onlineCourseOpen.onlineCourseOpenRank" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.teacher }}</td>
              <td>{{ item.schoolname }}</td>
              <td>{{ item.level }}</td>
              <td>{{ item.num }}</td>
            </tr>
          </table>
        </div>
        <h5 class="m-top150">3.4 在线精品课选课情况</h5>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，在线精品课程共计选课人数{{
            getUtils_Fun(onlineCourseSelect.onlineCourseTotalSelectNum)
          }}人，选课人数最多的课程是{{
            onlineCourseSelect.onlineCourseSelectRank[0].schoolname
          }}的《{{
            onlineCourseSelect.onlineCourseSelectRank[0].name
          }}》，选课人数排名（前十五名）的课程信息如下表所示：
        </p>
        <div class="chart_name">表20 在线精品课程选课人数排名（前十五名）</div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>课程名称</th>
              <th>课程负责人</th>
              <th>所属院校</th>
              <th>级别</th>
              <th>选课人数</th>
            </tr>
            <tr v-if="onlineCourseSelect.onlineCourseSelectRank.length == 0" class="nothing">
              <td colspan="6">无</td>
            </tr>
            <tr
              v-else
              v-for="(item, index) in onlineCourseSelect.onlineCourseSelectRank"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.teacher }}</td>
              <td>{{ item.schoolname }}</td>
              <td>{{ item.level }}</td>
              <td>{{ item.num }}</td>
            </tr>
          </table>
        </div>
      </div>

      <div class="chart_box page-box">
        <div class="division">4. 视频公开课建设及应用情况</div>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{
            nowDay
          }}日，依据专业与课程服务中心监测平台统计，视频公开课共纳入监测{{
            videoCourseRun.videoCourseNum
          }}门，其中，国家规范教材有{{ videoCourseRun.textbook }}门、课程思政示范课有{{
            videoCourseRun.demonstration
          }}门、公共基础课有{{ videoCourseRun.basicCourse }}门、教学能力比赛获奖作品有{{
            videoCourseRun.competition
          }}门。 目前，视频公开课已有{{
            videoCourseRun.videoCourseCoreIndicator.参建院校
          }}所院校和{{
            videoCourseRun.videoCourseCoreIndicator.教师参建人次
          }}名教师参与建设与应用；总访问量达{{
            getUtils_Fun(videoCourseRun.videoCourseCoreIndicator.总访问量)
          }}次，总开课期数为{{
            getUtils_Fun(videoCourseRun.videoCourseCoreIndicator.总开课期数)
          }}期，总课时数为{{
            getUtils_Fun(videoCourseRun.videoCourseCoreIndicator.总课时数)
          }}课时，总选课人数{{
            getUtils_Fun(videoCourseRun.videoCourseCoreIndicator.总选课人数)
          }}人。具体建设及应用情况如下：
        </p>
        <h5>4.1 各省视频公开课建设情况</h5>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，视频公开课共纳入监测{{
            porvinceVideoCourse.videoCourseNum
          }}门，其中，{{
            changeCity(porvinceVideoCourse.videoCourseProvinceRank[0].province)
          }}建设课程数量最多，共{{
            porvinceVideoCourse.videoCourseProvinceRank[0].total
          }}门，具体各省建设课程数量排名（前十五名）如下表所示：
        </p>
        <div class="chart_name">表21 各省建设视频公开课程数量排名（前十五名）</div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>省份</th>
              <th>建设课程数</th>
              <th>选课人数</th>
            </tr>
            <tr v-if="porvinceVideoCourse.videoCourseProvinceRank.length == 0" class="nothing">
              <td colspan="4">无</td>
            </tr>
            <tr
              v-else
              v-for="(item, index) in porvinceVideoCourse.videoCourseProvinceRank.slice(0, 15)"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.province }}</td>
              <td>{{ item.total }}</td>
              <td>{{ item.studynum }}</td>
            </tr>
          </table>
        </div>
        <h5 style="margin-top: 0">4.2 视频公开课访问情况</h5>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，视频公开课共计访问量{{
            getUtils_Fun(videoCourseVisit.videoCourseTotalVisitNum)
          }}，访问量最高的课程是{{ videoCourseVisit.videoCourseVisitRank[0].schoolname }}的《{{
            videoCourseVisit.videoCourseVisitRank[0].name
          }}》，访问量排名（前十五名）的课程信息如下表所示：
        </p>
        <div class="chart_name">表22 视频公开课访问量排名（前十五名）</div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>课程名称</th>
              <th>课程负责人</th>
              <th>所属院校</th>
              <th>课程类型</th>
              <th>访问量</th>
            </tr>
            <tr v-if="videoCourseVisit.videoCourseVisitRank.length == 0" class="nothing">
              <td colspan="6">无</td>
            </tr>
            <tr v-else v-for="(item, index) in videoCourseVisit.videoCourseVisitRank" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.teacher }}</td>
              <td>{{ item.schoolname }}</td>
              <td>{{ item.courseclass }}</td>
              <td>{{ item.num }}</td>
            </tr>
          </table>
        </div>
      </div>

      <div class="chart_box page-box">
        <h5>4.3 视频公开课选课情况</h5>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，视频公开课共计选课人数{{
            getUtils_Fun(videoCourseSelect.videoCourseTotalSelectNum)
          }}人，选课人数最多的课程是{{
            videoCourseSelect.videoCourseSelectRank[0].schoolname
          }}的《{{
            videoCourseSelect.videoCourseSelectRank[0].name
          }}》，选课人数（前十五名）的课程信息如下表所示：
        </p>
        <div class="chart_name">表23 视频公开课选课人数排名（前十五名）</div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>课程名称</th>
              <th>课程负责人</th>
              <th>所属院校</th>
              <th>课程类型</th>
              <th>选课人数</th>
            </tr>
            <tr v-if="videoCourseSelect.videoCourseSelectRank.length == 0" class="nothing">
              <td colspan="6">无</td>
            </tr>
            <tr
              v-else
              v-for="(item, index) in videoCourseSelect.videoCourseSelectRank"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.teacher }}</td>
              <td>{{ item.schoolname }}</td>
              <td>{{ item.courseclass }}</td>
              <td>{{ item.num }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <el-backtop></el-backtop>
  </div>
</template>

<script>
import circularChart from "@/components/chart/circularChart.vue"; // 引入圆形图表
import discountChart from "@/components/chart/discountChart.vue"; // 引入折线图图表
import distributionChart from "@/components/chart/distributionChart.vue"; // 地图
import pageToPDF from "@/utils/htmlToPdf.js";
export default {
  components: {
    circularChart,
    discountChart,
    distributionChart,
  },
  data() {
    return {
      completeNum: 0, //统计接口数量
      colorList: ["#3B85FB", "#FD398E", "#04F995", "#E8FF6C", "#00EEF2", "#0DA1FD", "#F50512"], // 柱状图或折线图的颜色
      mapcolorList: ["#ffd9d9"],
      loading: "", // 是否导出加载中
      startDay: "",
      endDay: "",
      // 现在的时间
      endDay: "",
      nowYear: "",
      nowMonth: "",
      nowDay: "",
      header: {
        zykName: "",
        zykNum: "",
      },
      countryUserRank: [], // 2.1.4.5.2 按照用户活跃情况分析
      provinceUser: {}, // 2.2.1 各省用户建设及应用情况
      provinceCourse: {}, // 2.2.2 各省课程建设及应用情况
      provinceResource: {}, // 2.2.3 各省资源建设及应用情况
      // 2.3.1 资源库用户建设及应用情况 1. 用户新增情况
      userAddCase: {
        dataList: [],
        transverse: [],
        sTotal: 0,
        tTotal: 0,
        total: 0,
      },
      // 2.3.1 资源库用户建设及应用情况 2. 用户活跃情况
      userActiveCase: {
        userVisitTotal: 0,
        student: {},
        teacher: {},
        enterprise: {},
        social: {},
      },
      userVisitRank: [], // 2.3.1 资源库用户建设及应用情况 3. 用户访问情况排名
      courseBuildAnalysis: {}, // 2.3.2 资源库课程建设及应用情况
      // 2.3.3 资源库资源建设及应用情况
      resourceBuildAnalysis: {
        pieDataList: [],
      },
      // 2.3.4.1 用户运行情况
      userRunCase: {
        tTotal: 0,
        sTotal: 0,
        userTotal: 0,
        userAddDataList: [],
        userAddTransverse: [],
        activeStudent: {},
        activeTeacher: {},
        activeEnterprise: {},
        activeSocial: {},
        activeUserTotal: 0,
        userActiveLine: {
          dataList: [],
          transverseData: [],
          legendList: [],
        },
      },
      // 2.3.4.2 课程运行情况
      courseRunCase: {
        sNum: 0,
        pMum: 0,
        total: 0,
      },
      // 2.3.4.3 资源运行情况
      resourceRunCase: {
        pieDataList: [],
      },
      // 3.在线精品课建设及应用情况
      onlineCourseBuild: {
        countryVal: 0,
        provinceVal: 0,
        schoolVal: 0,
        school: 0,
        teacher: 0,
        totalVisit: 0,
        totalCourse: 0,
        totalClass: 0,
        totalStudent: 0,
        totalInteract: 0,
      },
      // 3.1 各省在线精品课建设情况
      porvinceOnlineCourse: {
        dataList: [],
        total: 0,
      },
      // 3.2 在线精品课访问情况
      onlineCourseVisit: {},
      // 3.3 在线精品课开课情况
      onlineCourseOpen: {},
      // 3.4 在线精品课程选课情况
      onlineCourseSelect: {},
      // 4、视频公开课运行监测情况分析
      videoCourseRun: {
        textbook: 0,
        demonstration: 0,
        basicCourse: 0,
        competition: 0,
      },
      // 4.1 各省视频公开课建设情况
      porvinceVideoCourse: {},
      // 4.2 视频公开课访问情况
      videoCourseVisit: {},
      // 4.3 视频公开课选课情况
      videoCourseSelect: {},
    };
  },
  created() {
    if (this.$route.query) {
      let token = this.$route.query.token;
      sessionStorage.setItem("lrmv2token", token);
      let zykid = this.$route.query.zykid;
      sessionStorage.setItem("zykId", zykid);
      this.startDay = this.$route.query.startDay;
      this.endDay = this.$route.query.endDay;
      this.nowYear = this.$route.query.endDay.slice(0, 4);
    }
    this.nowDate(); // 获取当前时间日期
    this.getCountryZykUserActiveAnalysis(); // 2.1.4.5.2 按照用户活跃情况分析
    this.getProvinceUserBuildAnalysis(); // 2.2.1 各省用户建设及应用情况
    this.getProvinceCourseBuildAnalysis(); // 2.2.2 各省课程建设及应用情况
    this.getProvinceZyBuildAnalysis(); // 2.2.3 各省资源建设及应用情况
    this.getZykUserAddCase(); // 2.3.1 资源库用户建设及应用情况 1. 用户新增情况
    this.getZykUserActiveCase(); // 2.3.1 资源库用户建设及应用情况 2. 用户活跃情况
    this.getUserVisitRank(); // 2.3.1 资源库用户建设及应用情况 3. 用户访问情况排名
    this.getZykCourseBuildAnalysis(); // 2.3.2 资源库课程建设及应用情况
    this.getZykResourceBuildAnalysis(); // 2.3.3 资源库资源建设及应用情况
    this.getCountryZykUserRunCase(); // 2.3.4.1 用户运行情况
    this.getCountryCourseRunCase(); // 2.3.4.2 课程运行情况
    this.getCountryZykResourceRunCase(); // 2.3.4.3 资源运行情况
    this.getOnlineCourseBuildAnalysis(); // 3.在线精品课建设及应用情况
    this.getProvinceBuildCourseNum(); // 3.1 各省在线精品课建设情况
    this.getOnlineCourseVisitNum(); // 3.2 在线精品课访问情况
    this.getOnlineCourseOpenNum(); // 3.3 在线精品课开课情况
    this.getOnlineCourseSelectNum(); // 3.4 在线精品课程选课情况
    this.getVideoCourseRunAnalysis(); // 4、视频公开课运行监测情况分析
    this.getProvinceVideoCourseBuild(); // 4.1 各省视频公开课建设情况
    this.getVideoCourseVisit(); // 4.2 视频公开课访问情况
    this.getVideoCourseSelect(); // 4.3 视频公开课选课情况
  },
  watch: {
    completeNum(val) {
      console.log(val);
    },
  },
  methods: {
    // 截取当前日期的赋值操作
    nowDate() {
      let Frist = this.$route.query.endDay.indexOf("-") + 1;
      let last = this.$route.query.endDay.lastIndexOf("-") + 1;
      let regx = /^[0]+/;
      this.nowMonth = this.$route.query.endDay.slice(Frist, last - 1).replace(regx, "");
      this.nowDay = this.$route.query.endDay.slice(last, this.$route.query.endDay.length);
    },

    changeCity(data) {
      if (data == "北京" || data == "上海" || data == "天津" || data == "重庆") {
        return data + "市";
      } else {
        return data + "省";
      }
    },

    getUtils_Fun(num) {
      const data =
        num > 100000000
          ? `${
              (num / 100000000).toFixed(2).toString().split(".")[1] === "00"
                ? (num / 100000000).toFixed(0)
                : (num / 100000000).toFixed(2)
            }亿`
          : num > 10000
          ? `${
              (num / 10000).toFixed(2).toString().split(".")[1] === "00"
                ? (num / 10000).toFixed(0)
                : (num / 10000).toFixed(2)
            }万`
          : num;
      return data;
    },
    // 导出pdf文件
    exportPdf() {
      const lableList = document.getElementsByClassName("page-box");
      pageToPDF(`国家端整体月报copy2`, this.$refs.pdfContent, lableList);
    },
    // 2.1.4.5.2 按照用户活跃情况分析
    getCountryZykUserActiveAnalysis() {
      this.$axios
        .post(this.$apiurls.getCountryZykUserActiveAnalysis, {
          loading: false,
        })
        .then((res) => {
          this.countryUserRank = res.data;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.2.1 各省用户建设及应用情况
    getProvinceUserBuildAnalysis() {
      this.$axios
        .post(this.$apiurls.getProvinceUserBuildAnalysis, {
          loading: false,
        })
        .then((res) => {
          this.provinceUser = res.data;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.2.2 各省课程建设及应用情况
    getProvinceCourseBuildAnalysis() {
      this.$axios
        .post(this.$apiurls.getProvinceCourseBuildAnalysis, {
          loading: false,
        })
        .then((res) => {
          this.provinceCourse = res.data;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.2.3 各省资源建设及应用情况
    getProvinceZyBuildAnalysis() {
      this.$axios
        .post(this.$apiurls.getProvinceZyBuildAnalysis, {
          loading: false,
        })
        .then((res) => {
          this.provinceResource = res.data;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.3.1 资源库用户建设及应用情况 1. 用户新增情况
    getZykUserAddCase() {
      this.$axios
        .post(
          this.$apiurls.getZykUserAddCase,
          { endDay: this.endDay, startDay: this.startDay, type: 0 },
          {
            loading: false,
          }
        )
        .then((res) => {
          let data = res.data;
          this.userAddCase.dataList = [data.student.value, data.teacher.value];
          this.userAddCase.transverse = data.student.name;
          this.userAddCase.sTotal = data.student.value.reduce(function (a, b) {
            return a + b;
          }, 0);
          this.userAddCase.tTotal = data.teacher.value.reduce(function (a, b) {
            return a + b;
          }, 0);
          this.userAddCase.total = this.userAddCase.sTotal + this.userAddCase.tTotal;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.3.1 资源库用户建设及应用情况 2. 用户活跃情况
    getZykUserActiveCase() {
      this.$axios
        .post(
          this.$apiurls.getZykUserActiveCase,
          { endDay: this.endDay, startDay: this.startDay, type: 0 },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.userActiveCase = res.data;
          let sum = 0;
          res.data.userActive.forEach((item) => {
            sum += item.logNum;
          });
          this.userActiveCase.userVisitTotal = sum;
          this.userActiveCase.student = res.data.userActive.find((item) => item.role === "学生");
          this.userActiveCase.teacher = res.data.userActive.find((item) => item.role === "教师");
          this.userActiveCase.enterprise = res.data.userActive.find(
            (item) => item.role === "企业用户"
          );
          this.userActiveCase.social = res.data.userActive.find(
            (item) => item.role === "社会学习者"
          );
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.3.1 资源库用户建设及应用情况 3. 用户访问情况排名
    getUserVisitRank() {
      this.$axios
        .post(
          this.$apiurls.getUserVisitRank,
          { endDay: this.endDay, startDay: this.startDay, type: 0 },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.userVisitRank = res.data;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.3.2 资源库课程建设及应用情况
    getZykCourseBuildAnalysis() {
      this.$axios
        .post(
          this.$apiurls.getZykCourseBuildAnalysis,
          { endDay: this.endDay, startDay: this.startDay, type: 0 },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.courseBuildAnalysis = res.data;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.3.3 资源库资源建设及应用情况
    getZykResourceBuildAnalysis() {
      this.$axios
        .post(
          this.$apiurls.getZykResourceBuildAnalysis,
          { endDay: this.endDay, startDay: this.startDay, type: 0 },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.resourceBuildAnalysis = res.data;
          let data = res.data.resourceDistribution;
          this.resourceBuildAnalysis.pieDataList = [
            {
              name: "视频类",
              value: data.video,
            },
            {
              name: "动画类",
              value: data.animation,
            },
            {
              name: "图形图像类",
              value: data.image,
            },
            {
              name: "虚拟仿真类",
              value: data.simulation,
            },
            {
              name: "文本类",
              value: data.text,
            },
            {
              name: "微课类",
              value: data.microCourses,
            },
            {
              name: "音频类",
              value: data.audio,
            },
            {
              name: "ppt和富媒体等",
              value: data.ppt + data.courseware + data.media,
            },
            {
              name: "其他",
              value: data.other,
            },
          ];
          this.completeNum = this.completeNum + 1;
        });
    },
    // 2.3.4.1 用户运行情况
    getCountryZykUserRunCase() {
      this.$axios
        .post(
          this.$apiurls.getCountryZykUserRunCase,
          { endDay: this.endDay, startDay: this.startDay, type: 0 },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.userRunCase = res.data;
          // 1. 用户新增情况
          this.userRunCase.tTotal = res.data.userAddCase.teacher.value.reduce(function (a, b) {
            return a + b;
          }, 0);
          this.userRunCase.sTotal = res.data.userAddCase.student.value.reduce(function (a, b) {
            return a + b;
          }, 0);
          this.userRunCase.userTotal = this.userRunCase.tTotal + this.userRunCase.sTotal;
          this.userRunCase.userAddDataList = [
            res.data.userAddCase.teacher.value,
            res.data.userAddCase.student.value,
          ];
          this.userRunCase.userAddTransverse = res.data.userAddCase.teacher.name;

          // 2. 用户活跃情况
          let sum = 0;
          res.data.userActiveCase.userActive.forEach((item) => {
            sum += item.logNum;
          });
          this.userRunCase.logTotal = sum;
          this.userRunCase.activeStudent = res.data.userActiveCase.userActive.find(
            (item) => item.role === "学生"
          );
          this.userRunCase.activeTeacher = res.data.userActiveCase.userActive.find(
            (item) => item.role === "教师"
          );
          this.userRunCase.activeEnterprise = res.data.userActiveCase.userActive.find(
            (item) => item.role === "企业用户"
          );
          this.userRunCase.activeSocial = res.data.userActiveCase.userActive.find(
            (item) => item.role === "社会学习者"
          );
          this.userRunCase.activeUserTotal = res.data.userActiveCase.userActiveTotal;
          this.userRunCase.userActiveLine = res.data.userActiveCase.userActiveMonthRole;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.3.4.2 课程运行情况
    getCountryCourseRunCase() {
      this.$axios
        .post(
          this.$apiurls.getCountryCourseRunCase,
          { endDay: this.endDay, startDay: this.startDay, type: 0 },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.courseRunCase = res.data;
          this.courseRunCase.sNum = res.data.courseNew.separateContent.find(
            (item) => item.name === "standardNum"
          ).value;
          this.courseRunCase.pMum = res.data.courseNew.separateContent.find(
            (item) => item.name === "personalityNum"
          ).value;
          this.courseRunCase.total = this.courseRunCase.sNum + this.courseRunCase.pMum;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.3.4.3 资源运行情况
    getCountryZykResourceRunCase() {
      this.$axios
        .post(
          this.$apiurls.getCountryZykResourceRunCase,
          { endDay: this.endDay, startDay: this.startDay, type: 0 },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.resourceRunCase = res.data;
          let data = res.data.resourceDistribution;
          this.resourceRunCase.pieDataList = [
            {
              name: "视频类",
              value: data.video,
            },
            {
              name: "动画类",
              value: data.animation,
            },
            {
              name: "图形图像类",
              value: data.image,
            },
            {
              name: "虚拟仿真类",
              value: data.simulation,
            },
            {
              name: "文本类",
              value: data.text,
            },
            {
              name: "微课类",
              value: data.microCourses,
            },
            {
              name: "音频类",
              value: data.audio,
            },
            {
              name: "ppt和富媒体等",
              value: data.ppt + data.courseware + data.media,
            },
            {
              name: "其他",
              value: data.other,
            },
          ];
          this.completeNum = this.completeNum + 1;
        });
    },
    // 3.在线精品课建设及应用情况
    getOnlineCourseBuildAnalysis() {
      this.$axios
        .post(this.$apiurls.getOnlineCourseBuildAnalysis, {
          loading: false,
        })
        .then((res) => {
          this.onlineCourseBuild = res.data;
          this.onlineCourseBuild.countryVal = res.data.onlineCourseLevelNums.find(
            (item) => item.kname === "国家级"
          ).num;
          this.onlineCourseBuild.provinceVal = res.data.onlineCourseLevelNums.find(
            (item) => item.kname === "省级"
          ).num;
          this.onlineCourseBuild.schoolVal = res.data.onlineCourseLevelNums.find(
            (item) => item.kname === "校级"
          ).num;
          let name = res.data.OnlineCourseCoreIndicatorStat.name;
          let value = res.data.OnlineCourseCoreIndicatorStat.value;
          let arr = [];
          for (let i = 0; i < name.length; i++) {
            arr.push({ name: name[i], value: value[i] });
          }
          this.onlineCourseBuild.school = arr.find((item) => item.name === "参建院校").value;
          this.onlineCourseBuild.teacher = arr.find((item) => item.name === "教师参建人次").value;
          this.onlineCourseBuild.totalVisit = arr.find((item) => item.name === "总访问量").value;
          this.onlineCourseBuild.totalCourse = arr.find((item) => item.name === "总开课期数").value;
          this.onlineCourseBuild.totalClass = arr.find((item) => item.name === "总课时数").value;
          this.onlineCourseBuild.totalStudent = arr.find(
            (item) => item.name === "总选课人数"
          ).value;
          this.onlineCourseBuild.totalInteract = arr.find(
            (item) => item.name === "累计互动次数"
          ).value;

          this.completeNum = this.completeNum + 1;
        });
    },

    // 3.1 各省在线精品课建设情况
    getProvinceBuildCourseNum() {
      this.$axios
        .post(this.$apiurls.getProvinceBuildCourseNum, {
          loading: false,
        })
        .then((res) => {
          this.porvinceOnlineCourse.dataList = res.data.onlineCourseRankByProvince;
          let sum = 0;
          res.data.onlineCourseRankByProvince.forEach((item) => {
            sum += item.total;
          });
          this.porvinceOnlineCourse.total = sum;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 3.2 在线精品课访问情况
    getOnlineCourseVisitNum() {
      this.$axios
        .post(this.$apiurls.newGetOnlineCourseVisitNum, {
          loading: false,
        })
        .then((res) => {
          this.onlineCourseVisit = res.data;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 3.3 在线精品课开课情况
    getOnlineCourseOpenNum() {
      this.$axios
        .post(this.$apiurls.getOnlineCourseOpenNum, {
          loading: false,
        })
        .then((res) => {
          this.onlineCourseOpen = res.data;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 3.4 在线精品课程选课情况
    getOnlineCourseSelectNum() {
      this.$axios
        .post(this.$apiurls.getOnlineCourseSelectNum, {
          loading: false,
        })
        .then((res) => {
          this.onlineCourseSelect = res.data;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 4、视频公开课运行监测情况分析
    getVideoCourseRunAnalysis() {
      this.$axios
        .post(this.$apiurls.getVideoCourseRunAnalysis, {
          loading: false,
        })
        .then((res) => {
          this.videoCourseRun = res.data;
          let name = res.data.videoCourseNunForType.name;
          let value = res.data.videoCourseNunForType.value;
          let arr = [];
          for (let i = 0; i < name.length; i++) {
            arr.push({ name: name[i], value: value[i] });
          }
          this.videoCourseRun.textbook = arr.find((item) => item.name === "国家规范教材").value;
          this.videoCourseRun.demonstration = arr.find(
            (item) => item.name === "课程思政示范课"
          ).value;
          this.videoCourseRun.basicCourse = arr.find((item) => item.name === "公共基础课").value;
          this.videoCourseRun.competition = arr.find((item) => item.name === "教学能力比赛").value;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 4.1 各省视频公开课建设情况
    getProvinceVideoCourseBuild() {
      this.$axios
        .post(this.$apiurls.getProvinceVideoCourseBuild, {
          loading: false,
        })
        .then((res) => {
          this.porvinceVideoCourse = res.data;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 4.2 视频公开课访问情况
    getVideoCourseVisit() {
      this.$axios
        .post(this.$apiurls.getVideoCourseVisit, {
          loading: false,
        })
        .then((res) => {
          this.videoCourseVisit = res.data;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 4.3 视频公开课选课情况
    getVideoCourseSelect() {
      this.$axios
        .post(this.$apiurls.getVideoCourseSelect, {
          loading: false,
        })
        .then((res) => {
          this.videoCourseSelect = res.data;
          this.completeNum = this.completeNum + 1;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  margin: 0px;
  padding: 0px;
}
.analysisReport {
  // height: 10960px;
  background: #fff;
  .analysisReport_box {
    // width: 86.7%;
    // margin: 0px auto;
    .page-box {
      // padding: 7% 0;
      // height: 2740px;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      // border: 1px solid red;
      .division {
        position: relative;
        clear: both;
        font-weight: bold;
        font-size: 44px;
        color: #1d244e;
        margin: 35px 0;
      }
      .m-top150 {
        margin-top: 150px;
      }
      .biaoge {
        width: 95%;
        font-weight: 540 !important;
        margin: 10px auto 25px;
        color: #272a3f !important;
        .course {
          text-align: center;
          margin: 0px 10px;
          tr {
            font-size: 22px;
            height: 45px;
            line-height: 45px;
            color: #707f9d;
            &:nth-child(2n) {
              background: rgba(11, 201, 212, 0.2);
              color: #566178;
            }
            &:nth-child(2n-1) {
              background: rgba(73, 187, 233);
              color: #566178;
            }
            &:first-child {
              background: rgb(88, 136, 248);
              color: #fff;
            }
          }
        }
      }
    }
    .chart_box {
      h3 {
        font-size: 50px;
        margin-bottom: 35px;
        color: #1d244e;
      }
      h4 {
        font-size: 42px;
        margin-bottom: 35px;
        color: #1d244e;
      }
      h5 {
        font-size: 40px;
        margin-bottom: 25px;
        margin-top: 35px;
        color: #1d244e;
      }
      h6 {
        font-weight: 700;
        font-size: 39px;
        color: #1d244e;
        // line-height: 40px;
        margin-bottom: 15px;
        margin-top: 50px;
      }
      p {
        font-weight: 540 !important;
        font-size: 35px !important;
        text-indent: 2em;
        line-height: 70px;
        color: #272a3f !important;
      }
      .echartsHeight {
        height: 400px;
        margin: 10px auto 0px;
      }
      .chart_name {
        font-weight: 540 !important;
        text-align: center;
        font-size: 32px;
        color: #272a3f;
        clear: both;
        // margin-bottom: 30px;
        margin-top: 20px;
      }
    }
  }
  .export {
    width: 88px;
    height: 32px;
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 1;
  }
}

::v-deep .el-progress-bar__innerText {
  color: #000;
  font-size: 25px;
}
</style>
